// extracted by mini-css-extract-plugin
export default {"wrap":"MenuCategoriesComponent_wrap__dlgY6","listBlock":"MenuCategoriesComponent_listBlock__IztWb","btnBlock":"MenuCategoriesComponent_btnBlock__sKqqS"};